import { createVisibleCategoriesAtom } from "../create-visible-catalog-atoms";
import indoorCategoriesAtom from "./categories";
import indoorCategoriesItemOffersAtom from "./categories-item-offers";

/** Categories on the INDOOR (QR) menu right now (inside their window, non-empty). */
const indoorVisibleCategoriesAtom = createVisibleCategoriesAtom(
  indoorCategoriesAtom,
  indoorCategoriesItemOffersAtom,
);

export default indoorVisibleCategoriesAtom;
